import { Flex, Text } from "@chakra-ui/react";
import { LocalTime } from "@js-joda/core";
import { TimePicker } from "../../shared/components/TimePicker/TimePicker";
import { OvernightBadge } from "./OvernightBadge";
import { TrashButton } from "./TrashButton";

export function TimeTangePicker(props: {
  timeSlot: { startTime: LocalTime; endTime: LocalTime };
  onUpdateTimeSlot: (startTime: LocalTime, endTime: LocalTime) => void;
  onRemoveTimeSlot: () => void;
}) {
  const isOvernight = !props.timeSlot.startTime.isBefore(props.timeSlot.endTime);

  return (
    <Flex direction="column">
      {isOvernight && <OvernightBadge />}
      <Flex direction="row" gap={4}>
        <Flex align="center" direction="row" gap={2}>
          <Text>Start time</Text>
          <TimePicker
            value={props.timeSlot.startTime}
            onChange={(newStartTime) =>
              props.onUpdateTimeSlot(newStartTime, props.timeSlot.endTime)
            }
          />
        </Flex>
        <Flex align="center" direction="row" gap={2}>
          <Text>End time</Text>
          <TimePicker
            value={props.timeSlot.endTime}
            onChange={(newEndTime) => props.onUpdateTimeSlot(props.timeSlot.startTime, newEndTime)}
          />
        </Flex>
        <TrashButton onClick={props.onRemoveTimeSlot} />
      </Flex>
    </Flex>
  );
}
